import { create } from 'zustand';
import type { EventStatus } from '~/features/events/interfaces/models';
import type { ID, UnixTime } from '~/interfaces/common';

interface EventsState {
  events: Record<ID, EventStatus>;
  eventIds: ID[];
  newArrivalDate: UnixTime;
  setEvent: (event: EventStatus) => void;
  setEvents: (events: EventStatus[]) => void;
  setNewArrivalDate: (date: UnixTime) => void;
  removeEvent: (eventId: ID) => void;
  resetEvents: () => void;
}

export const useEventsStore = create<EventsState>((set) => ({
  events: {},
  eventIds: [],
  newArrivalDate: 0,

  setEvent: (event) =>
    set((state) => ({
      events: {
        ...state.events,
        [event.id]: event,
      },
    })),

  setEvents: (newEvents) =>
    set((state) => {
      const lastId =
        state.eventIds.length === 0 ? 0 : state.eventIds[state.eventIds.length - 1] + 1;
      const events = { ...state.events };
      const eventIds = [...state.eventIds];

      newEvents.forEach((event, i) => {
        const id = lastId + i;
        events[id] = { ...event, id };
        eventIds.push(id);
      });

      return { events, eventIds };
    }),

  setNewArrivalDate: (date) => set({ newArrivalDate: date }),

  removeEvent: (eventId) =>
    set((state) => ({
      events: {
        ...state.events,
        [eventId]: {
          ...state.events[eventId],
          isDeleted: true,
        },
      },
    })),

  resetEvents: () => set({ events: {}, eventIds: [] }),
}));
